import { formatterDate, optionsFormatter, ReportingTypologyOption, yearOptions } from "../../../utils"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import clsx from "clsx"
import { GetAllRIDMonitoringClose, resetGetAllRIDFilters, resetGetAllRIDStatus, setGetAllRIDFiltersStatus, setGetAllRIDFiltersYear } from "./slice"
import { RIDEntityDTO } from "./dataService/dto"
import { SelectCustom } from "../../../ui/molecules/select"
import Button from "../../../ui/molecules/button"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"


export function RIDMonitoringListClose() {
    const dispatch = useAppDispatch()
    const ridState = useAppSelector(state => state.rid)
    useEffect(() => {
        dispatch(setGetAllRIDFiltersStatus('CHIUSA'))
    }, [dispatch])
    useEffect(() => {
        if (ridState.getAllRidStatus === 'successfully' &&
            ridState.getAllRidResponse !== undefined
        ) {
            dispatch(resetGetAllRIDStatus())
        }
    }, [ridState.getAllRidStatus])

    const showMotivations = (rid: RIDEntityDTO) => {
        const motivations: string[] = []
        if (rid.documentalControlProtocolInfo !== null)
            motivations.push(`Controllo documentale: ${rid.documentalControlProtocolInfo}`)
        if (rid.certificateRequestProtocolInfo !== null)
            motivations.push(`Richiesta certificato: ${rid.certificateRequestProtocolInfo}`)
        if (rid.reportingInfo !== null)
            motivations.push(`Segnalazione: ${optionsFormatter(rid.reportingInfo, ReportingTypologyOption)}`)
        if (rid.other !== null)
            motivations.push(`Altro: ${rid.other}`)

        return (
            <ul>{motivations.map(m => (<li>- {m}</li>))}</ul>
        )
    }

    return (
        <div className="p-6">
            <div className="flex flex-row items-end gap-2 w-[50%]">
                <MadfarmStaticSelect
                    noOptionsMessage=""
                    placeholder={'Anno'}
                    value={ridState.getAllRidFilters.year}
                    options={yearOptions}
                    onChange={(value) => {
                        //@ts-ignore
                        const newValue = value !== null ? value.value : null
                        dispatch(setGetAllRIDFiltersYear(newValue))
                    }}

                />
                <ButtonComponent
                    size={"lg"}
                    iconPosition={"off"}
                    variant={"outline"}
                    label="Pulisci"
                    color={"gray"}
                    onClick={() => dispatch(resetGetAllRIDFilters())}
                />
                <ButtonComponent
                    size={"lg"}
                    iconPosition={"off"}
                    variant={"outline"}
                    label="Cerca"
                    color={"orange"}
                    onClick={() => dispatch(GetAllRIDMonitoringClose(ridState.getAllRidFilters))}
                    disabled={ridState.getAllRidFilters.year === undefined}
                />
            </div>
            <div className="mt-4 overflow-x-auto rounded-xl border border-brandPrimary-100 bg-white shadow-sm">
                <table id="users-table" className="w-[100%]">
                    <thead className="h-[52px] uppercase">
                        <tr>
                            <th className="rounded-tl-lg">Sede</th>
                            <th>Regione</th>
                            <th>Operatore</th>
                            <th>Cod. Op</th>
                            <th>Data</th>
                            <th>Scadenza</th>
                            <th>Prot. Partenza</th>
                            <th>Motivazione</th>
                            <th>Funzionario</th>
                            <th>Stato Compilazione</th>
                            <th className="w-10 rounded-tr-lg">Stato</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ridState.getAllRidResponseMonitoringClose?.data.map((rid, index) =>
                                <tr key={index} className={clsx("text-[#4D797F]", index % 2 === 0 ? "bg-[#F2F7F7]" : "bg-white")}>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{formatterDate(rid.date)}</td>
                                    <td></td>
                                    <td>{rid.departureProtocolInfo}</td>
                                    <td className="w-[30%]">{showMotivations(rid)}</td>
                                    <td>{rid.officerInfo}</td>
                                    <td>{rid.compilationState}</td>
                                    <td className={clsx("w-[30%]", rid.requestState === 'APERTA' ? "text-[#FF941A]" : "text-[#26AB45]")}>{rid.requestState}</td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>

        </div >
    )
}